import * as React from "react";
import { cn } from "@/lib/utils.js";

/**
 * Privacy Policy + Terms of Service links pointing at the marketing site.
 * Kept in one place so Settings, the app footer, and the pre-login screens
 * all reference the same URLs.
 */
export function LegalLinks({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-center justify-center gap-4 text-xs text-gray-400", className)}>
      <a
        href="https://www.homethyst.com/privacy"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-gray-600 transition-colors"
      >
        Privacy Policy
      </a>
      <a
        href="https://www.homethyst.com/terms"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-gray-600 transition-colors"
      >
        Terms of Service
      </a>
    </div>
  );
}
